module.exports = __webpack_public_path__ + "img/girl_at_piano.6534affa.jpg";